<template>
  <hm-content title>
    <div class="flex item-center mb20">
      <el-input class="mr10" size="small" style="width:800px;" placeholder="请输入链接" v-model="keyword" clearable></el-input>
      <el-button class="mr10" size="small" type="primary" @click="transition">转换</el-button>
    </div>
    <div>
      <el-image
        style="width: 500px; height:500px;"
        class="mr10"
        :src="imageTest"
      ></el-image>
    </div>

    <div class="flex item-center mb20 mt40">
      <el-input class="mr10" size="small" style="width:800px;" placeholder="请输入申报单号" v-model="declareSn" clearable></el-input>
      <el-button class="mr10" size="small" type="primary" @click="getVolcengineOcrResult">查询</el-button>
    </div>
    <div class="image-input">
      <div class="image">
        <img :src="declareImg" >
        <!-- <el-image
        style="width: 500px;"
        fit="fit"
        :src="declareImg"
      ></el-image> -->
      <div class="text-overlay">
        <!-- fontSize:item.height +'px', lineHeight: item.height +'px' -->
        <div v-for="(item,index) in charInfos" :key="index"  :style="style(item)" class="text-item">{{item.ch}}</div>
      </div>
      </div>
      <div class="input">
        <el-input placeholder="请滑动图片提取文字" style="width:500px; height: 500px;" v-model="textResult" clearable></el-input>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      keyword: "",
      imageTest: "",
      declareSn: "2570276788839508",
      textResult: "",
      declareImg: "",
      charInfos: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    document.onmouseup = () => {
      this.testSelection();
    };
  },
  methods: {
    style(item) {
      const maxFontSize = 20;
      
      return {
        position: "absolute",
        fontSize: item.height > maxFontSize ? maxFontSize+ "px" : item.height + "px",
        lineHeight: item.height  > maxFontSize ? maxFontSize+ "px" : item.height + "px",
        left: item.x + "px",
        top: item.y + "px",
      };
    },
    async transition() {
      const params = {
        url: this.keyword,
        type: "UrlToBase64",
      };
      const { result, errMsg } = await this.$store.dispatch(
        "img2base64",
        params
      );
      this.imageTest = errMsg;
      console.log("this.imageTest:", this.imageTest);
    },

    async getVolcengineOcrResult() {
      try {
        const { result } = await this.$store.dispatch(
          "getVolcengineOcrResult",
          {
            declareSn: this.declareSn,
          }
        );
        // console.log('getVolcengineOcrResult',res);
        this.declareImg = result.declareImg;
        this.charInfos = result.ocrNormalResponse.data.chars.flat();
      } catch (error) {}
    },

    testSelection() {
      let selection = window.getSelection();
      this.textResult = selection.toString();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.image-input {
  display: flex;
  position: relative;
  .input {
    margin-left: 40px;
    el-input {
      width: 500px;
      height: 500px;
      .el-input__inner {
        height: 500px;
      }
    }
  }
  image {
    position: relative;
    width: 500px;
    min-height: 500px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .text-overlay {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      color: white;
      box-sizing: border-box;
      /* 单个文本元素样式 */
      .text-item {
        position: absolute;
        color: white;
        white-space: nowrap;
        /* 新增文本阴影和背景色 */
        /* text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7); */
        padding: 2px 5px;
        color: rgba(255, 255, 255, 0.01);
      }
    }
  }
}
::selection {
  background: rgba(67, 103, 143, 0.2);
  color: #fff;
}
</style>
